import queryString from 'query-string';

export default function parseSearchTermQueryString(queryTerm) {
  const parsedSearchQuery = queryString.parse(queryTerm);

  const { t } = parsedSearchQuery;

  return t;
}
